'use strict';

(function () {
  'use strict';

  angular.module('vnext').directive('msAriaNavLink', msAriaNavLink);

  msAriaNavLink.$inject = ['$state', '$rootScope'];

  function msAriaNavLink($state, $rootScope) {
    var directive = {
      link: link,
      restrict: 'A'
    };
    return directive;

    function link(scope, element, attr) {
      // Run it when the view loads
      // (this occurs after the initial $stateChangeSuccess)
      changeAttrs();

      // And also on every $stateChangeSuccess
      $rootScope.$on('$stateChangeSuccess', function () {
        changeAttrs();
      });

      function changeAttrs() {
        if ($state.is(attr.uiSref) || $state.includes(attr.uiSref)) {
          element[0].setAttribute('aria-current', 'page');
        } else {
          element[0].removeAttribute('aria-current');
        }
      }
    }
  }
})();